import { render, staticRenderFns } from "./card-cart-prescription.vue?vue&type=template&id=98e4637a&scoped=true&"
import script from "./card-cart-prescription.vue?vue&type=script&lang=js&"
export * from "./card-cart-prescription.vue?vue&type=script&lang=js&"
import style0 from "./card-cart-prescription.vue?vue&type=style&index=0&id=98e4637a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e4637a",
  null
  
)

export default component.exports